module.exports = __webpack_public_path__ + "img/Epiito_App_Icons_Desktop.e139be21.png";